import { Component } from 'react';
import Helmet from 'react-helmet';

import Icon from 'react-fa';

import { titles } from '../../data';
import CommonComponents from './CommonComponents';
import Title from '../modules/Title';

export default class Volunteering extends Component {
  render() {

    const page = this.props.page;

    return (
      <div>
        <Helmet title={titles.services.volunteering} titleTemplate={titles.titleTemplate} />
        <CommonComponents {...this.props}>

          {/* 移送サービス */}
          <section className="services__item" id="pickup-service">
            <Title header="h2" title="移送サービス" />
            <div className="services__content">
              <div className="services__content__overview">
                <Icon name="lightbulb-o" />
                <div dangerouslySetInnerHTML={{__html: page.acf.pickup_overview}} />
              </div>
              <div className="services__project">

                {/* 福祉有償運送サービス */}
                <article className="services__project__item" id="pickup-service-1">
                  <div className="services__project__item__info">
                    <Title header="h3" title="福祉有償運送サービス" />
                    <div className="services__project__item__info__desc" dangerouslySetInnerHTML={{__html: page.acf.pickup_shipping_overview}} />
                  </div>

                  { /* 年会費 */  }
                  <section className="services__fee">
                    <Title header="h4" title="年会費" />
                    {page.acf.pickup_shipping_annual_fee
                      ?
                        <table className="services__fee__table">
                          <tbody>
                            {
                              page.acf.pickup_shipping_annual_fee.map(item => {
                                return(
                                  <tr key={item.name}>
                                    <th>{item.name}</th>
                                    <td>{item.fee}</td>
                                  </tr>
                                )
                              })
                            }
                          </tbody>
                        </table>
                      : ''
                    }
                  </section>

                  { /* 福祉有償運送等料金 */  }
                  <section className="services__fee">
                    <Title header="h4" title="福祉有償運送等料金" />
                    {page.acf.pickup_shipping_another_fee !== false
                      ? <table className="services__fee__table">
                        <tbody>
                          {
                            page.acf.pickup_shipping_another_fee.map(item => {
                              return(
                                <tr key={item.name}>
                                  <th>{item.name}</th>
                                  <td>{item.fee}</td>
                                </tr>
                              )
                            })
                          }
                        </tbody>
                        </table>
                      : ''
                    }
                  </section>

                  { /* 申請・ご利用の流れ */ }
                  <section className="services__flow">
                    <Title header="h4" title="申請・ご利用の流れ" />
                    <div className="services__flow__list">
                      {page.acf.pickup_shipping_flow.map((item, index) => {
                        return (
                          <div className="services__flow__item" key={item.title}>
                            <div className="flow__icon">
                              <div className="flow__icon__inner">
                                <span className="step">{`STEP ${index + 1}`}</span>
                                <Icon name={item.icon} />
                              </div>
                            </div>
                            <div className="flow__content">
                              <h4 className="flow__content__title">{item.title}</h4>
                              <div className="flow__content__desc" dangerouslySetInnerHTML={{__html: item.desc}} />
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </section>

                  { /* 注意事項 */ }
                  <section className="services__note">
                    <Title header="h4" title="注意事項" />
                    <div className="services__note__content" dangerouslySetInnerHTML={{__html: page.acf.pickup_shipping_note}} />
                  </section>
                </article>
              </div>
            </div>
          </section>

          {/* 地域支え合い */}
          <section className="services__item" id="community-support">
            <Title header="h2" title="地域支え合い" />
            <div className="services__content">
              {page.acf.cs_overview
                ?
                  <div className="services__content__overview">
                    <Icon name="lightbulb-o" />
                    <div dangerouslySetInnerHTML={{__html: page.acf.cs_overview}} />
                  </div>
                : ''
              }

              <div className="services__project">

                {/* 支えあい事業 (保険外実費サービス) */}
                {page.acf.cs_service_four_overview || page.acf.cs_service_four_fee || page.acf.cs_service_four_content
                  ?
                    <article className="services__project__item" id="unique-support">
                      <div className="services__project__item__info">
                        <Title header="h3" title="支えあい事業" />
                        <div className="services__project__item__info__desc" dangerouslySetInnerHTML={{__html: page.acf.cs_service_four_overview}} />
                      </div>

                      { /* サービス詳細 */  }
                      <section className="services__fee">
                        <Title header="h4" title="サービス詳細" />
                        {page.acf.cs_service_four_content
                          ?
                            <table className="services__fee__table os-service-four">
                              <thead>
                                <tr>
                                  <th>作業項目</th>
                                  <th>作業内容</th>
                                </tr>
                              </thead>
                              <tbody>
                                {
                                  page.acf.cs_service_four_content.map(item => {
                                    return(
                                      <tr key={item.title}>
                                        <th>{item.title}</th>
                                        <td dangerouslySetInnerHTML={{__html: item.content}} />
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </table>
                          : ''
                        }
                      </section>

                      { /* 利用料金 */  }
                      <section className="services__fee">
                        <Title header="h4" title="利用料金" />
                        {page.acf.cs_service_four_fee
                          ?
                            <table className="services__fee__table">
                              <tbody>
                                {
                                  page.acf.cs_service_four_fee.map(item => {
                                    return(
                                      <tr key={item.title}>
                                        <th>{item.title}</th>
                                        <td dangerouslySetInnerHTML={{__html: item.content}} />
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </table>
                          : ''
                        }
                      </section>

                    </article>
                  : ''
                }

              </div>

            </div>
          </section>

          {/* 介護予防・集いの場 */}
          <section className="services__item" id="nursing-prevention">
            <Title header="h2" title="介護予防・集いの場" />
              {page.acf.np_overview || page.acf.np_members_voices || page.acf.np_eyecatch
                ?
                  <div className="services__content">

                    {/* アイキャッチ */}
                    {page.acf.np_eyecatch
                      ?  <figure className="services__content__eyecatch">
                          <img src={page.acf.np_eyecatch} alt="コーヒー教室の様子" />
                          <figcaption className="services__content__eyecatch__caption">
                            <p>つどいの場 H28.3月</p>
                            <p>「男による男のためのコーヒー教室」</p>
                            <p>開催しました</p>
                          </figcaption>
                        </figure>
                      : ''
                    }

                    {/* 概要 */}
                    {page.acf.np_overview
                      ?  <div className="services__content__overview">
                          <Icon name="lightbulb-o" />
                          <div dangerouslySetInnerHTML={{__html: page.acf.np_overview}} />
                        </div>
                      : ''
                    }

                    {/* 会員の方からいただいた言葉 */}
                    {page.acf.np_members_voices
                      ?
                        <div className="services__project">
                          <div className="services__project__item services__project__item--members-voices">
                            <Title header="h4" title="会員の方からいただいた言葉" />
                            <div>
                              {
                                page.acf.np_members_voices.map((voice, index) => {
                                  return (
                                    <article key={`members-voice-${index}`} className="voice">
                                      <Title header="h5" title={voice.title} />
                                      <div dangerouslySetInnerHTML={{__html: voice.content}} />
                                    </article>
                                  );
                                })
                              }
                            </div>
                          </div>
                        </div>
                      : ''
                    }
                  </div>
                : ''
              }
          </section>
        </CommonComponents>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Services/Volunteering.js
 **/